var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 100 100","width":"24","height":"24"}},[_c('circle',{attrs:{"cx":50,"cy":50,"r":50,"fill":_vm.fillColor}}),_c('text',{attrs:{"x":"50%","y":"50%","fill":"#fff","font-size":60,"dominant-baseline":"central","text-anchor":"middle"}},[_vm._v(" "+_vm._s(_vm.firstLetter.toUpperCase())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }